'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: 'nas-tym', component: _containers.OurTeam }),
    _react2.default.createElement(_reactRouter.Redirect, { from: 'o-nas', to: 'nas-tym' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'kontakty', component: _containers.Contacts }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'detske-tabory' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Camps }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '16.-23.7.2017\'', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '22.-29.7.2017', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '5.-12.8.2017', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '12.-19.8.2017', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '25.-29.10.2017', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '10.-17.2.2018', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '21.-28.7.2018\'', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '28.7.-4.8.2018', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '4.-11.8.2018', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '26.-30.10.2018', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Redirect, { from: 'undefined', to: '/detske-tabory' }),
      _react2.default.createElement(_reactRouter.Route, { path: ':date/:hash', component: _containers.Report }),
      _react2.default.createElement(_reactRouter.Route, { path: ':date', component: _containers.Camp })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'primestske-tabory' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.SuburbanCamps }),
      _react2.default.createElement(_reactRouter.Redirect, { from: 'undefined', to: '/primestske-tabory' }),
      _react2.default.createElement(_reactRouter.Route, { path: ':date', component: _containers.SuburbanCamp }),
      _react2.default.createElement(_reactRouter.Route, { path: ':date/:hash', component: _containers.Report })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'sportovni-pripravka' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.TrainingGroups }),
      _react2.default.createElement(_reactRouter.Route, { path: ':variant', component: _containers.TrainingGroup })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'prihlaska', component: _containers.Application }),
    _react2.default.createElement(_reactRouter.Route, { path: 'vsestranny-pohybovy-rozvoj', component: _containers.ComplexMovementPreparation }),
    _react2.default.createElement(_reactRouter.Route, { path: 'zabavny-motivacni-program', component: _containers.EntertainingMotivationProgram }),
    _react2.default.createElement(_reactRouter.Route, { path: 'on-line-aplikace', component: _containers.OnlineApp }),
    _react2.default.createElement(_reactRouter.Route, { path: 'skolni-pobyty', component: _containers.SchoolCamps }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1125
// module chunks = 0